<template>

  <div class="concern-model" v-if="concernIsNotZero">
    <a name="concern-model" />

    <div class="mb-1">
      Your patient is a higher risk than <span class="strong">{{patientPercentile}}%</span> of currently hospitalized patients in ICU &amp; Acute Care units.
    </div>

    <div class="rectangle" :style="rectangleStyle">
      <div class="separator"></div>
      <div class="separator"></div>
      <div class="separator"></div>
      <div class="separator"></div>
      <div class="separator"></div>
      <div class="separator"></div>
      <div class="separator"></div>
      <div class="separator"></div>
      <div class="separator"></div>

      <div
        class="patient-marker"
        :style="`left: ${patientPercentile}%;`"
      >
        <div class="patient-marker-bullseye" />
      </div>

    </div>

    <div class="separator-labels-container mt-1_2">
      <div class="separator-label fs-sm"></div>
      <div class="separator-label fs-sm"><span>10%</span></div>
      <div class="separator-label fs-sm"><span>20%</span></div>
      <div class="separator-label fs-sm"><span>30%</span></div>
      <div class="separator-label fs-sm"><span>40%</span></div>
      <div class="separator-label fs-sm"><span>50%</span></div>
      <div class="separator-label fs-sm"><span>60%</span></div>
      <div class="separator-label fs-sm"><span>70%</span></div>
      <div class="separator-label fs-sm"><span>80%</span></div>
      <div class="separator-label fs-sm"><span>90%</span></div>
    </div>

    <div class="mt-1">
      <span class="strong">Risk Score Distribution</span>
      (for currently hospitalized patients in ICU &amp; Acute Care units)
    </div>
  </div><!-- .concern-model -->

</template>

<script>
import { mapGetters } from 'vuex';

export default {

  name: 'ConcernModel',

  props: {
    greenYellowCutoff: { type: Number, required: true },
    yellowRedCutoff:   { type: Number, required: true },
    patientPercentile: { type: Number, required: true },
    concernColor:      { type:String },
  },

  data () {
    return {
    };
  },

  computed: {

    ...mapGetters([
      'concernIsZero',
    ]),

    concernIsNotZero () {
      return !( this.concernIsZero );
    },

    rectangleStyle () {
      return `background: linear-gradient( 90deg, #3e7d32 0%, #97A533 ${this.greenYellowCutoff}%, #D37428 ${ this.yellowRedCutoff }%, #b71c1c 100% );`;
    },
  },

  methods: {
  }
};
</script>

<style lang="scss">
.patient-marker {
  position: absolute;
  margin-left: -20px;
  top: 30px;
  width: 40px;
  height:40px;
  border-radius: 50%;
  border: 5px solid white;
  background-color: transparent;
}

.patient-marker-bullseye {
  height: 50%;
  width: 50%;
  border-radius: 50%;
  background-color:white;
  margin-top: 25%;
  margin-left: 25%;
}

.rectangle {
  box-sizing: border-box;
  padding: 0;
  width: 100%;
  height: 100px;
  border: 1px solid black;
 /* background: linear-gradient(90deg, #3e7d32 0%, #97A533 20%, #D37428 50%, #b71c1c 100%);*/
  /* green-yellow: #97A533, yellow-red: #D37428 */
  position: relative;

  .separator {
    height: 100%;
    width: 10%;
    border-right: 1px solid white;
    display: inline-block;
  }
}

.separator-labels-container {
  box-sizing: border-box;
  padding: 0;
  width: 100%;

  .separator-label {
    display: inline-block;
    width: 10%;

    span {
      margin-left: -10px;
    }
  }
}
</style>
